import React from 'react';
import Section from 'components/common/Section';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { version } from 'config';
import { useTranslation } from 'react-i18next';

const FooterStandard = () => {
  const { t } = useTranslation();
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  };
  return (
    <>
      <Section bg="dark" className="pt-8 pb-4 light">
        <div
          className="position-absolute btn-back-to-top cursor-pointer bg-dark"
          onClick={scrollToTop}
        >
          <FontAwesomeIcon
            icon="chevron-up"
            transform="rotate-45"
            className="text-600"
          />
        </div>
        <Row className="justify-content-between">
          <Col lg={4}>
            <h5 className="text-uppercase text-white opacity-85 mb-3">Gestodo</h5>
            <p className="text-600">
              {t('LANDING.FOOTER_DESCRIPTION')}
            </p>
          </Col>
          <Col lg={3} className="mt-5 mt-lg-0">
            <h5 className="text-uppercase text-white opacity-85 mb-3">{t('LANDING.FOOTER_PLATFORM')}</h5>
            <ul className="list-unstyled">
              <li className="mb-1">
                <Link className="text-600" to="#features">{t('LANDING.NAV_FEATURES')}</Link>
              </li>
              <li className="mb-1">
                <Link className="text-600" to="#benefits">{t('LANDING.NAV_BENEFITS')}</Link>
              </li>
              <li className="mb-1">
                <Link className="text-600" to="#faq">{t('LANDING.NAV_FAQ')}</Link>
              </li>
              <li className="mb-1">
                <Link className="text-600" to="/login">{t('LANDING.FOOTER_CLIENT_ACCESS')}</Link>
              </li>
              <li className="mb-1">
                <Link className="text-600" to="/waitlist">{t('LANDING.FOOTER_REGISTER')}</Link>
              </li>
            </ul>
          </Col>
          <Col lg={3} className="mt-5 mt-lg-0">
            <h5 className="text-uppercase text-white opacity-85 mb-3">{t('LANDING.FOOTER_CONTACT')}</h5>
            <ul className="list-unstyled">
              <li className="mb-1">
                <a className="text-600" href="https://driconmax.com" target="_blank" rel="noopener noreferrer">
                  Driconmax
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Section>

      <section className="bg-dark py-0 text-center fs--1 light">
        <hr className="my-0 border-600 opacity-25" />
        <div className="container py-3">
          <Row className="justify-content-between">
            <Col xs={12} sm="auto">
              <p className="mb-0 text-600">
                Gestodo{' '}
                <span className="d-none d-sm-inline-block">| </span>
                <br className="d-sm-none" /> {new Date().getFullYear()} &copy;{' '}
                <a
                  className="text-white opacity-85"
                  href="https://driconmax.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Driconmax
                </a>
              </p>
            </Col>
            <Col xs={12} sm="auto">
              <p className="mb-0 text-600">v{version}</p>
            </Col>
          </Row>
        </div>
      </section>
    </>
  );
};

export default FooterStandard;
